export type TaskStatusKey =
  | "Not Started"
  | "Started"
  | "Completed"
  | "Deferred"
  | "Сanceled";

export type MeetingStatusKey = "Planned" | "Held" | "Not Held";

export type OpportunityStageKey =
  | "Prospecting"
  | "Qualification"
  | "Negotiation"
  | "Logistic"
  | "Closed Won"
  | "Closed Lost";

export type ProjectStatusKey =
  | "Draft"
  | "Active"
  | "Closed"
  | "Paused"
  | "Canceled";

export type ProjectTaskColumnKey = "To Do" | "In Progress" | "Review" | "Done";

type StatusColorEntry = { color: string };

type TaskStatusColors = Record<TaskStatusKey, StatusColorEntry>;
type MeetingStatusColors = Record<MeetingStatusKey, StatusColorEntry>;
type OpportunityStageColors = Record<OpportunityStageKey, StatusColorEntry>;
type ProjectStatusColors = Record<ProjectStatusKey, StatusColorEntry>;
type ProjectTaskColumnColors = Record<ProjectTaskColumnKey, StatusColorEntry>;

export const taskStatusColors: TaskStatusColors = {
  "Not Started": { color: "#E07F42" },
  Started: { color: "#4292E0" },
  Completed: { color: "#5CA357" },
  Deferred: { color: "#4356FF" },
  Сanceled: { color: "#C03131" },
};

export const meetingStatusColors: MeetingStatusColors = {
  Planned: { color: "#FF9800" },
  Held: { color: "#4CAF50" },
  "Not Held": { color: "#F44336" },
};

export const opportunityStageColors: OpportunityStageColors = {
  Prospecting: { color: "#9C27B0" },
  Qualification: { color: "#2196F3" },
  Negotiation: { color: "#FF9800" },
  Logistic: { color: "#FF9800" },
  "Closed Won": { color: "#4CAF50" },
  "Closed Lost": { color: "#F44336" },
};

export const projectStatusColors: ProjectStatusColors = {
  Draft: { color: "#E07F42" },
  Active: { color: "#4292E0" },
  Closed: { color: "#4CAF50" },
  Paused: { color: "#4356FF" },
  Canceled: { color: "#C03131" },
};

export const projectTaskColumnColors: ProjectTaskColumnColors = {
  "To Do": { color: "#E07F42" },
  "In Progress": { color: "#4292E0" },
  Review: { color: "#4356FF" },
  Done: { color: "#5CA357" },
};

const PROJECT_COLUMN_COLOR_PALETTE = [
  "#E07F42",
  "#4292E0",
  "#5CA357",
  "#4356FF",
  "#C03131",
  "#FF9800",
  "#4CAF50",
  "#F44336",
  "#9C27B0",
  "#2196F3",
];

export const getProjectStatusColor = (status: string): string => {
  if (status in projectStatusColors) {
    return projectStatusColors[status as ProjectStatusKey].color;
  }
  return "#757575";
};

export const getProjectTaskColumnColor = (status: string): string => {
  if (status in projectTaskColumnColors) {
    return projectTaskColumnColors[status as ProjectTaskColumnKey].color;
  }
  return "#757575";
};

const isHexColor = (value: string): boolean =>
  /^#?[0-9A-Fa-f]{6}$/.test(value);

export const normalizeProjectColumnColor = (
  raw: string | number | null | undefined,
  fallbackName?: string,
): string => {
  if (typeof raw === "string") {
    if (isHexColor(raw)) {
      return raw.startsWith("#") ? raw : `#${raw}`;
    }
    const numeric = Number(raw);
    if (Number.isFinite(numeric)) {
      return PROJECT_COLUMN_COLOR_PALETTE[
        Math.abs(numeric) % PROJECT_COLUMN_COLOR_PALETTE.length
      ];
    }
  }

  if (typeof raw === "number" && Number.isFinite(raw)) {
    return PROJECT_COLUMN_COLOR_PALETTE[
      Math.abs(raw) % PROJECT_COLUMN_COLOR_PALETTE.length
    ];
  }

  return fallbackName ? getProjectTaskColumnColor(fallbackName) : "#757575";
};
